module.exports = __webpack_public_path__ + "static/gm-33-d943a76fc8c857b8bcbdb542b3c166b0.jpg";